export const AskExportAction = ({target,route,id,onNavigate}) => {
  if(!target || !route || !route.startsWith('/') || route.startsWith('//'))return null;
  const url=route + (route.includes('?')?'&':'?') + 'airpack=1';
  return <button data-testid={`ask-review-airpack-${id}`} onClick={()=>onNavigate(url,{title:'Report and AIRPack options',confirmation:'Opening the report and export options…'})}>Review AIRPack on this report</button>;
};
